<template>
<div class="y-icon" :style="`background: ${color}1a;width: ${size*2}px;`">
  <i :class="icon" :style="`color: ${color};font-size: ${size}px;`"></i>
</div>
</template>

<script>
export default {
  name: "YIcon",
  props:{
    icon:{
      type:String,
      default:'el-icon-food'
    },
    color:{
      type:String,
      default:'#0183FF'
    },
    size:{
      type:Number,
      default:21
    }
  }
}
</script>

<style lang="less" scoped>
.y-icon{
  border-radius: 50%;
  aspect-ratio: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/YUI/YIcon/index.vue